import { User, MapPin, Armchair } from "lucide-react";
import { DETALLE_COMPRAS } from "@/constants/testIds";

/** Fila de un boleto: asignación (nombre) y utilización (estado) por separado. */
export const BoletoDetalleFila = ({ boleto, numero }) => {
  const nombre = (boleto.asistenteNombre || "").trim();
  const utilizado = boleto.estado === "VALIDADO";
  const ubicacion = [
    boleto.salon,
    boleto.mesa !== null && boleto.mesa !== undefined ? `Mesa ${boleto.mesa}` : null,
  ].filter(Boolean);

  return (
    <li
      data-testid={DETALLE_COMPRAS.boleto(boleto.id)}
      className="flex items-center gap-3 py-2.5 text-sm"
    >
      <span className="w-7 h-7 shrink-0 grid place-items-center rounded-full bg-muted text-muted-foreground text-[11px] tabular-nums">
        {numero}
      </span>
      <div className="flex-1 min-w-0">
        <div
          data-testid={DETALLE_COMPRAS.boletoAsistente(boleto.id)}
          className={nombre ? "text-foreground truncate flex items-center gap-1.5" : "text-muted-foreground italic"}
        >
          {nombre ? (
            <>
              <User className="w-3.5 h-3.5 text-accent shrink-0" strokeWidth={1.6} />
              {nombre}
            </>
          ) : (
            "Pendiente de asignar"
          )}
        </div>
        <div
          data-testid={DETALLE_COMPRAS.boletoUbicacion(boleto.id)}
          className="mt-0.5 text-xs text-muted-foreground flex items-center gap-3"
        >
          {boleto.salon && (
            <span className="inline-flex items-center gap-1">
              <MapPin className="w-3 h-3" strokeWidth={1.6} />
              {boleto.salon}
            </span>
          )}
          {boleto.mesa !== null && boleto.mesa !== undefined && (
            <span className="inline-flex items-center gap-1">
              <Armchair className="w-3 h-3" strokeWidth={1.6} />
              Mesa {boleto.mesa}
            </span>
          )}
          {ubicacion.length === 0 && "—"}
        </div>
      </div>
      <span
        data-testid={DETALLE_COMPRAS.boletoEstado(boleto.id)}
        className={
          "shrink-0 text-[10px] uppercase tracking-wider px-2 py-1 rounded-full border " +
          (utilizado
            ? "text-muted-foreground bg-muted border-border"
            : "text-emerald-700 dark:text-emerald-300 bg-emerald-500/10 border-emerald-500/40")
        }
      >
        {utilizado ? "Utilizado" : "Disponible"}
      </span>
    </li>
  );
};

export default BoletoDetalleFila;
